<template>
  <article>
    <div class="dataForm">
      <div class="dataForm__item">
        <div class="dataForm__name">ID</div>
        <el-input v-model="detail.awid" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">标题</div>
        <el-input v-model="detail.title" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">申请人</div>
        <el-select class="filter__input" size="mini" v-model="detail.opid">
          <el-option :label="item.nickname" :value="item.opid" v-for="(item, index) in operLists" :key="index"></el-option>
        </el-select>
      </div>
      <!--
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">之前下家</div>
        <el-input v-model="detail.agent" placeholder="可不填" size="mini" class="dataForm__input"></el-input>
      </div>
      -->
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">下家</div>
        <el-select class="filter__input" size="mini" v-model="detail.acid" filterable>
          <el-option :label="item.name" :value="item.acid" v-for="(item, index) in adChnLists" :key="index"></el-option>
        </el-select>
        <div class="dataForm__item ml-10">
          <el-button size="mini" @click="adChnDialog = !adChnDialog">添加上家</el-button>
        </div>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">项目</div>
        <el-select placeholder="请选择项目" size="mini" v-model="detail.adid" filterable>
          <el-option v-for="item in adLists" :key="item.adid" :label="item.project" class="dataForm__input"  :value="item.adid"> </el-option>
        </el-select>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">是否使用折扣</div>
        <el-radio-group v-model="detail.use_discount">
          <div class="dib mr-20">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </div>
        </el-radio-group>
      </div>
      <div class="dataForm__item mt-16" v-if="detail.use_discount">
        <div class="dataForm__name">底价折扣</div>
        <el-input v-model="detail.min_discount" placeholder="税后实际折扣" size="mini" style="width:200px" class="dataForm__input">
          <template slot="append">%</template>
        </el-input>
        <div class="ml-30 mr-20">上家折扣</div>
        <el-input v-model="detail.aver_discount" placeholder="上家给的折扣" size="mini" style="width:200px" class="dataForm__input">
          <template slot="append">%</template>
        </el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">总单数</div>
        <el-input v-model="detail.total" placeholder="" size="mini" class="dataForm__input">
          <template slot="append">单</template>
        </el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">拍手费</div>
        <el-input v-model="detail.agency_fees" placeholder="" size="mini" class="dataForm__input">
          <template slot="append">￥</template>
        </el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">要求</div>
        <el-input type="textarea" v-model="detail.demand" rows=3 placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">口令</div>
        <el-input type="textarea" v-model="detail.keyword" rows=4 placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">候选地址</div>
        <el-checkbox-group v-model="acaidLists" @change="handleAcaidsChange">
          <el-checkbox v-for="item in addressLists" :label="item.acaid" :key="item.acaid">{{item.address}}</el-checkbox>
        </el-checkbox-group>
        <i class="el-icon-edit" @click="editAddress" v-if="detail.acid !== ''"></i>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">地址</div>
        <el-input type="textarea" v-model="detail.address" rows=5 placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">优惠券链接</div>
        <el-input type="textarea" v-model="detail.coupon_url" rows=2 placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <!--
      <div class="dataForm__item mt-20">
        <div class="dataForm__name ml40">引导图</div>
        <div class="headimg-container relative" style="width:250px">
          <uploadImageList :list.sync="detail.tutor" :itype="5" :width="400" @uploadMultipleSuccess="uploadMultipleSuccess"></uploadImageList>
        </div>
      </div>
      -->
      <div class="dataForm__item mt-20">
        <div class="dataForm__name ml40">引导</div>
        <div>
            <div class="dataForm__item mt-16">
              <el-input type="textarea" v-model="detail.guide.first_desc" rows=4 placeholder="1.复制口令，进入官方旗舰店直播间" size="mini" class="dataForm__input"></el-input>
              <div class="headimg-container relative ml-20" style="width:250px">
                <uploadHeadImage :url.sync="detail.guide.first_img" :filename="filename" :itype="5"></uploadHeadImage>
              </div>
            </div>
            <div class="dataForm__item mt-16">
              <el-input type="textarea" v-model="detail.guide.secord_desc" rows=4 placeholder="2.直播间5号链接，选择" size="mini" class="dataForm__input"></el-input>
              <div class="headimg-container relative ml-20" style="width:250px">
                <uploadHeadImage :url.sync="detail.guide.secord_img" :filename="filename" :itype="5"></uploadHeadImage>
              </div>
            </div>
            <div class="dataForm__item mt-16">
              <el-input type="textarea" v-model="detail.guide.third_desc" rows=4 placeholder="3.一号最多可下3单，一单5件，实付649，建议先提交自己地址后改地址" size="mini" class="dataForm__input"></el-input>
              <div class="headimg-container relative ml-20" style="width:250px">
                <uploadHeadImage :url.sync="detail.guide.third_img" :filename="filename" :itype="5"></uploadHeadImage>
              </div>
            </div>
        </div>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">商品信息</div>
        <el-input v-model="detail.goods" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">订单金额</div>
        <el-input v-model="detail.amount" @input="(v)=>(detail.amount=v.replace(/[^\d.]/g,''))" placeholder="" size="mini" class="dataForm__input">
          <template slot="append">￥</template>
        </el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">单价</div>
        <el-input v-model="detail.price" @input="(v)=>(detail.price=v.replace(/[^\d.]/g,''))" placeholder="" size="mini" class="dataForm__input">
          <template slot="append">￥</template>
        </el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">应收单价</div>
        <el-input v-model="detail.income" @input="(v)=>(detail.income=v.replace(/[^\d.]/g,''))" placeholder="" size="mini" class="dataForm__input">
          <template slot="append">￥</template>
        </el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">是否收款</div>
        <el-radio-group v-model="detail.ieffect">
          <div class="dib mr-20">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </div>
        </el-radio-group>
      </div>

      <div class="dataForm__item mt-16">
        <div class="dataForm__name">状态</div>
        <el-radio-group v-model="detail.status">
          <div class="dib mr-20">
            <el-radio :label="0">下架</el-radio>
            <el-radio :label="1">运行</el-radio>
          </div>
        </el-radio-group>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name"></div>
        <button class="blue-large-btn" @click="adWatchwordEdit">保存</button>
      </div>
    </div>
    <el-dialog title="下家编辑" :visible.sync="adChnDialog" size="tiny" width="800px" center>
      <div class="flex fdr aic">
        <div class="dataForm">
          <div class="dataForm__item">
            <div class="dataForm__name">下家ID</div>
            <el-input v-model="adChnInfo.acid" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">微信号</div>
            <el-input v-model="adChnInfo.wechat" placeholder="" size="mini" class="dataForm__input"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">下家名</div>
            <el-input v-model="adChnInfo.name" placeholder="" size="mini" class="dataForm__input"></el-input>
          </div>
        </div>
      </div>
      <div class="flex fdc aic">
        <div class="flex mt-30">
          <div class="blue-large-btn mr-20" @click="adChnEdit">保存</div>
          <div class="gray-large-btn" @click="adChnDialog = false">取消</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="地址编辑" :visible.sync="addressDialog" size="tiny" width="1000px" center>
      <div class="flex fdr aic">
        <div class="dataForm">
          <div class="dataForm__item">
            <div class="dataForm__name">ID</div>
            <el-input v-model="addressInfo.acaid" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">下家ID</div>
            <el-input v-model="addressInfo.acid" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">替换提示</div>
            <div class="mr-30">汉字替换(2-5位)：{replace}</div>
            <div class="mr-30">数字替换(2-4位)：{digit}</div>
            <div class="mr-30">小写字母替换(2-4位)：{alphabet}</div>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">地址</div>
            <el-input type="textarea" :rows="4" v-model="addressInfo.address" placeholder="填多个，请使用 | 分割" size="mini" class="dataForm__input"></el-input>
          </div>
        </div>
      </div>
      <div class="flex fdc aic">
        <div class="flex mt-30">
          <div class="blue-large-btn mr-20" @click="adChnAddressEdit">保存</div>
          <div class="gray-large-btn" @click="addressDialog = false">取消</div>
        </div>
      </div>
    </el-dialog>
  </article>
</template>

<script>
import util from '../../../script/util'
import {adWatchwordDetail, adWatchwordEdit, adLists, operLists, adChnLists, adChnEdit, adChnAddressEdit, adChnAddressLists} from '../../../api/api'
import uploadHeadImage from '../../../components/uploadImage.vue'
import uploadImageList from '../../../components/uploadMultipleImageList.vue'
export default {
  name: 'adWatchwordEdit',
  components: {
    uploadHeadImage,
    uploadImageList
  },
  data () {
    return {
      opid: '',
      copy_awid: 0,
      awid: 0,
      detail: {
        title: '',
        awid: 0,
        adid: '',
        opid: '',
        acid: '',
        use_discount: 1,
        aver_discount: '',
        min_discount: '',
        total: '',
        agency_fees: 0,
        coupon_url: '',
        address: '{replace}',
        demand: '',
        keyword: '',
        tutor: [],
        guide: {
          first_desc: '1.复制口令，进入官方旗舰店直播间',
          first_img: '',
          secord_desc: '',
          secord_img: '',
          third_desc: '',
          third_img: ''
        },
        agent: '',
        extra: '',
        goods: '',
        amount: '',
        income: '',
        price: '',
        ieffect: 0,
        status: 1
      },
      dialog: false,
      adLists: [],
      operLists: [],
      adChnLists: [],
      adChnDialog: false,
      adChnInfo: {
        acid: 0,
        name: '',
        wechat: ''
      },
      addressDialog: false,
      acaidLists: [],
      addressLists: [],
      addressInfo: {
        acaid: 0,
        acid: '',
        address: ''
      }
    }
  },
  methods: {
    uploadMultipleSuccess (data) {
      this.detail.tutor = data
    },
    handleAdidChange () {
      this.adLists.forEach((item) => {
        if (item.adid === this.detail.adid) {
          this.detail.aver_discount = item.aver_discount
          this.detail.min_discount = item.min_discount
        }
      })
    },
    handleAcidChange () {
      if (this.detail.acid === '') {
        return
      }

      this.adChnLists.forEach((item) => {
        if (item.acid === this.detail.acid) {
          this.addressLists = item.address_lists
        }
      })
    },
    handleAcaidsChange () {
      let addressLists = []

      //  构造映射地址
      let mapAcaidAddress = {}
      this.addressLists.forEach((item) => {
        mapAcaidAddress[item['acaid']] = item['address']
      })

      this.acaidLists.forEach((acaid) => {
        addressLists.push(mapAcaidAddress[acaid])
      })

      this.detail.address = addressLists.join('|')
    },
    editAddress () {
      if (this.detail.acid === '') {
        return
      }
      this.addressDialog = true
      this.addressInfo['acaid'] = 0
      this.addressInfo['acid'] = this.detail.acid
      this.addressInfo['address'] = ''
    },
    getOperLists () {
      let params = {
        status: 1,
        l: 500,
        p: 1
      }
      operLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.operLists = data.d.lists.map((item, index) => {
            return {
              nickname: item.nickname,
              opid: item.opid
            }
          })
        }
      })
    },
    getAdChnAddressLists () {
      let params = {
        acid: this.detail.acid
      }

      adChnAddressLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.addressLists = data.d.lists
        }
      })
    },
    getAdChnLists () {
      let params = {
        l: 500,
        p: 1,
        opid: this.opid
      }

      if ([2, 4, 16].includes(this.opid)) {
        delete params.opid
      }

      adChnLists(params).then((res) => {
        let data = res.data || {c: -1}

        if (!data.c) {
          this.adChnLists = data.d.lists.map((item, index) => {
            return {
              name: item.name,
              acid: item.acid,
              address_lists: item.address_lists
            }
          })

          this.handleAcidChange()
        }
      })
    },
    getAdLists () {
      let params = {
        market: 3,
        l: 500,
        p: 1
      }
      adLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.adLists = data.d.lists.map((item, index) => {
            return {
              title: item.title,
              adid: item.adid,
              project: item.title + '(' + item.adid + ')',
              min_discount: item.min_discount,
              aver_discount: item.aver_discount
            }
          })
        }
      })
    },
    adWatchwordDetail (awid) {
      let params = {
        awid: awid
      }
      this.loading = true
      adWatchwordDetail(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          for (let key in this.detail) {
            this.detail[key] = data.d[key]
          }
          this.detail.awid = this.awid
        }
        this.loading = false
      })
    },
    adChnEdit () {
      let params = {
        acid: this.adChnInfo.acid,
        opid: this.opid,
        wechat: this.adChnInfo.wechat,
        name: this.adChnInfo.name
      }

      let content = ''

      if (params['name'] === '') {
        content = '名字不能为空'
      }

      if (params['wechat'] === '') {
        content = '微信名不能为空'
      }

      if (content) {
        this.$notify({
          title: '失败',
          message: content,
          type: 'error'
        })
        return
      }

      adChnEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.adChnDialog = false
          this.getAdChnLists()

          for (let key in this.adChnInfo) {
            this.adChnInfo[key] = ''
          }
          this.adChnInfo.acid = 0
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    adChnAddressEdit () {
      let params = {
        acaid: this.addressInfo.acaid,
        acid: this.addressInfo.acid,
        address: this.addressInfo.address
      }

      adChnAddressEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.addressDialog = false
          this.getAdChnLists()
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    adWatchwordEdit () {
      let params = util.cloneObj(this.detail)

      params['tutor'] = params['tutor'].join('|')
      params['guide'] = JSON.stringify(params['guide'])
      params['amount'] = parseFloat(params['amount'])
      params['price'] = parseFloat(params['price'])
      params['income'] = parseFloat(params['income'])

      let content = ''

      if (params['adid'] === '') {
        content = '没有选择项目'
      }

      if (params['opid'] === '') {
        content = '没有选择跟单人'
      }

      if (params['acid'] === '') {
        content = '没有选择下家'
      }

      if (params['title'] === '') {
        content = '请填写标题'
      }

      if (params['total'] === '') {
        content = '请设置总额度'
      }

      if (params['amount'] === '') {
        content = '请填写订单金额'
      }

      if (params['price'] === '' || util.isZero(params['income'])) {
        content = '请填写单价'
      }

      if (params['income'] === '' || util.isZero(params['income'])) {
        content = '请填写应收'
      }

      if (params['keyword'] === '') {
        content = '请填写口令'
      }

      if (params['demand'] === '') {
        content = '请填写要求'
      }

      if (params['price'] < params['income']) {
        content = '应收不可以比单价大'
      }

      if (params['price'] >= params['income'] * 10) {
        content = '应收不可以比单价的1折还小'
      }

      if (content) {
        this.$notify({
          title: '失败',
          message: content,
          type: 'error'
        })
        return
      }

      adWatchwordEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.$router.push('/adWatchwordList')
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    }
  },
  mounted () {
    this.opid = parseInt(window.localStorage.getItem('opid'))

    this.awid = parseInt(this.$route.query.awid || 0)
    if (this.awid) {
      this.adWatchwordDetail(this.awid)
    } else {
      this.detail.opid = this.opid
    }

    // 复制
    this.copy_awid = parseInt(this.$route.query.copy_awid || 0)
    if (this.copy_awid) {
      this.adWatchwordDetail(this.copy_awid)
    }

    this.getOperLists()
    this.getAdLists()
    this.getAdChnLists()
  },
  watch: {
    'detail.adid': 'handleAdidChange',
    'detail.acid': 'handleAcidChange'
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/ad/adWatchwordEdit.vue